










































import { Component } from "vue-property-decorator";
import QuizPage from "../../components/QuizPage";
import DebugData from "../../components/DebugData.vue";
@Component({
  components: {
    DebugData
  }
})
export default class Industry extends QuizPage {
  private created() {
    this.init("industry", "/defense");
  }

  private selectDropdown(event: Event): void {
    const element: HTMLSelectElement = event.target as HTMLSelectElement;
    const newfws = element.options[element.selectedIndex].getAttribute("data-frameworks");
    if (newfws != null && newfws.length > 0) {
      this.frameworks = new Set(newfws.split(","));
    } else {
      this.frameworks = new Set();
    }
    this.$store.commit("industryFrameworks", this.frameworks);
  }
}
